/**
 * @generated SignedSource<<9db1463d70329e87842d23b23308a5e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubLessonModelStatusChoices = "BLANK" | "BREAK" | "LEFT_SCHOOL" | "MISSED" | "NO_LESSON" | "OTHER_TEACHER" | "PRESENT" | "PRESENT_DOUBLE" | "PUPIL_ABSENT" | "STOPPED_LESSONS" | "TEACHER_ABSENT" | "%future added value";
export type AddReplacementLessonColumnToRegisterInput = {
  block: number;
  clientMutationId?: string | null | undefined;
  dayIndex: number;
  scheduledDate: string;
  startingYear: number;
  teacherId: string;
};
export type AddReplacementLessonColumnToRegisterMutation$variables = {
  input: AddReplacementLessonColumnToRegisterInput;
};
export type AddReplacementLessonColumnToRegisterMutation$data = {
  readonly addReplacementLessonColumnToRegister: {
    readonly errors: any | null | undefined;
    readonly lessonBlocks: ReadonlyArray<{
      readonly id: string;
      readonly lessons: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly rearrangedTimestamp: string | null | undefined;
            readonly replacementLessonColumnIndex: number | null | undefined;
            readonly scheduledTimestamp: string | null | undefined;
            readonly status: PianofunclubLessonModelStatusChoices;
          } | null | undefined;
        } | null | undefined>;
      };
    } | null | undefined> | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type AddReplacementLessonColumnToRegisterMutation = {
  response: AddReplacementLessonColumnToRegisterMutation$data;
  variables: AddReplacementLessonColumnToRegisterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddReplacementLessonColumnToRegisterPayload",
    "kind": "LinkedField",
    "name": "addReplacementLessonColumnToRegister",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonBlockNode",
        "kind": "LinkedField",
        "name": "lessonBlocks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonNodeConnection",
            "kind": "LinkedField",
            "name": "lessons",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledTimestamp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rearrangedTimestamp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "replacementLessonColumnIndex",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddReplacementLessonColumnToRegisterMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddReplacementLessonColumnToRegisterMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0d33fdcff5ab71373a37b86597abb504",
    "id": null,
    "metadata": {},
    "name": "AddReplacementLessonColumnToRegisterMutation",
    "operationKind": "mutation",
    "text": "mutation AddReplacementLessonColumnToRegisterMutation(\n  $input: AddReplacementLessonColumnToRegisterInput!\n) {\n  addReplacementLessonColumnToRegister(input: $input) {\n    success\n    errors\n    lessonBlocks {\n      id\n      lessons {\n        edges {\n          node {\n            id\n            scheduledTimestamp\n            rearrangedTimestamp\n            status\n            replacementLessonColumnIndex\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "024d1a76b004fb0bcc1c38d328166d6e";

export default node;
